<template>
	<div>
		<CRow><CButton size="sm" class="btn btn-link back-btn" 
					@click="backToTable()"><i class="fa fa-arrow-left"></i>Back</CButton>
		</CRow>
		<CCard class="p-2"> 
			<CCardHeader style="padding: 0.50rem 1.25rem">
				<CRow>
					<CCol lg="6">
						<h5>Trucker Settlement Information</h5>
					</CCol>
			     	<CCol lg="6">
			      		<div style="text-align: right">
			      			
	      					<CButton v-if="config.getPermission('trucker_settlement').download || true"  color="info" variant="outline" size="sm" @click="download"><i class="fa fa-download"></i> Download</CButton> &nbsp; 
			      			
			      		</div>
					</CCol>
				</CRow>
			</CCardHeader>
			<CCardBody>
					<CRow class="p-1">
						<CCol lg="12">
							<strong style="font-size:13px" class="text-dark">Trucker Settlement Information</strong>
						</CCol>	
					</CRow>
				
					
					<CRow class="p-2 mb-1 bg-custom-light text-dark rounded">
					 
						<CCol lg="3"  class="mt-1">
							<CRow>
								<CCol lg="12"  class="mt-1">
									<div class="form-group">
									<small>Vendor</small>
									<strong class="form-text mt-0">
										 {{dataParams.vendor ? dataParams.vendor.vendor_name : "N/A"}}
									</strong>
									</div>
								</CCol>
								<CCol lg="12" style="margin-top:-10px;">
									<div class="form-group">
									<small>Depot</small>
									<strong class="form-text mt-0 text-uppercase">
										{{dataParams.depot ? dataParams.depot.setting_name : "N/A"}}
									</strong>
									</div>
								</CCol>
								<CCol lg="12" style="margin-top:-10px;">
									<div class="form-group">
									<small>Delivery Date From</small>
									<strong class="form-text mt-0">
										{{dataParams.delivery_date_from ? moment.unix(dataParams.delivery_date_from).format('MMMM DD, YYYY') : "N/A"}}
									</strong>
									</div>
								</CCol>
							</CRow>
						</CCol>

						<CCol lg="3"  class="mt-1">
							<CRow>
								<CCol lg="12"  class="mt-1">		
									<div class="form-group">
									<small>Admin Fee</small>
									<strong class="form-text mt-0">
									  {{ (dataParams.admin_fee || 0) }}%
									</strong>
									</div>
								</CCol>
								<CCol lg="12" style="margin-top:-10px;">
									<div class="form-group">
									<small>Origin</small>
									<strong class="form-text mt-0 text-uppercase">
										{{dataParams.origin ? dataParams.origin.setting_name : "N/A"}}
									</strong>
									</div>
								</CCol>
								<CCol lg="12" style="margin-top:-10px;">
									<div class="form-group">
									<small>Delivery Date To</small>
									<strong class="form-text mt-0">
										{{dataParams.delivery_date_to ? moment.unix(dataParams.delivery_date_to).format('MMMM DD, YYYY') : "N/A"}}
									</strong>
									</div>
								</CCol>
							</CRow>
						</CCol>
						
						<CCol lg="3"  class="mt-1">
							<CRow>
								<CCol lg="12"  class="mt-1">	
									<div class="form-group">
									<small>Tax Type</small>
									<strong class="form-text mt-0 text-uppercase">
										{{dataParams.tax_type ? dataParams.tax_type : "N/A"}}
									</strong>
								</div>
								</CCol>
								<CCol lg="12" style="margin-top:-10px;">
									<div class="form-group">
									<small>Ref No.</small>
									<strong class="form-text mt-0 text-uppercase">
										{{dataParams.ref_no ? dataParams.ref_no : "N/A"}}
									</strong>
									</div>
								</CCol>
								<CCol lg="12" style="margin-top:-10px;">
									<div class="form-group">
									<small>Truck Type</small>
									<strong class="form-text mt-0 text-uppercase">
										{{dataParams.vehicle_type ? dataParams.vehicle_type.setting_name : "N/A"}}
									</strong>
									</div>
								</CCol>
							
							</CRow>
						</CCol>
						<CCol lg="3"  class="mt-1">
							<CRow>
								<CCol lg="12"  class="mt-1">	
									<div class="form-group">
									<small>Status</small>
									<strong class="form-text mt-0 text-uppercase" style="font-size: 25px;">
										{{dataParams.status ? dataParams.status : "N/A"}}
									</strong>
									</div>
								</CCol>
							</CRow>
								<CRow>
								<CCol lg="12"  class="mt-1">	
									<div class="form-group">
									<small>Invoice No.</small>
									<strong class="form-text mt-0 text-uppercase" style="font-size: 25px;">
										{{dataParams.invoice_no}}
									</strong>
									</div>
								</CCol>
							</CRow>
						</CCol>
						
						
		</CRow>	
				
			<hr>
					<CRow>
					<CCol lg="12">
						<CDataTable
						:items="displayedBooking"
						:fields="tableFields"
						class="table-borderless"
						:loading="searching"
						>
      				<!-- Currency formatting -->
					<template #subcon_rate="{ item }">
						<td class="font-weight-bold">
						{{ item.subcon_rate | number_format('currency') }}
						</td>
					</template>

					<template #toll_fee="{ item }">
						<td>
						{{ item.toll_fee | number_format('currency') }}
						</td>
					</template>
					<template #extra_helper="{ item }">
						<td>
						{{ item.extra_helper | number_format('currency') }}
						</td>
					</template>
					<template #backload_fee="{ item }">
						<td>
						{{ item.backload_fee | number_format('currency') }}
						</td>
					</template>
					<template #demurrage_fee="{ item }">
						<td>
						{{ item.demurrage_fee | number_format('currency') }}
						</td>
					</template>


					<template #parking_fee="{ item }">
						<td >
						{{ item.parking_fee | number_format('currency') }}
						</td>
					</template>

					<template #other_expenses="{ item }">
						<td class="text-muted">
						{{ item.other_expenses | number_format('currency') }}
						</td>
					</template>
					<template #other_deductions="{ item }">
						<td class="text-muted">
						{{ item.other_deductions | number_format('currency') }}
						</td>
					</template>
					<template #admin_fee="{ item }">
					<td class="text-muted">
							{{ item.admin_fee | number_format('currency') }}
					</td>
				</template>

					<template #total_amount="{ item }">
						<td >
						{{ item.total_amount | number_format('currency') }}
						</td>
					</template>

					<template #payment_amount="{ item }">
						<td class="text-success font-weight-bold">
						{{ item.payment_amount | number_format('currency') }}
						</td>
					</template>
					</CDataTable>

					<!-- Pagination -->
					<CPagination
					class="mt-2"
					:active-page.sync="currentPage"
					:pages="Math.ceil(bookingList.total / 20)"
					:activePage="currentPage"
					@update:activePage="updatePage"
					/>
					</CCol>
					</CRow>

			<!-- ✅ SUMMARY BELOW TABLE -->
				<CRow class="ml-3 mr-3 mt-3 justify-content-end">
					<CCol lg="4" md="6" sm="12">
						<CCard class="shadow-sm">
						<CCardHeader class="font-weight-bold text-center">
							Settlement Summary
						</CCardHeader>

						<CCardBody class="p-2">
						<ul class="list-group list-group-flush small">

					<!-- SUBCON -->
					<li class="list-group-item d-flex justify-content-between">
						Subcon Total
						<strong>{{ summary.subconTotal | number_format('currency') }}</strong>
					</li>

						<!-- VATABLE FEES -->
						<li
						v-if="
							companyFlags.isVat &&
							!companyFlags.isMarvel &&
							summary.vatableFeesTotal > 0
						"
						class="list-group-item d-flex justify-content-between"
						>


							<span>
							VATable Charges
							<small class="text-muted d-block">

								<template v-if="companyFlags.isMarvel">
								Subcon
								</template>

								<template v-else-if="companyFlags.isRoadwise">
								Subcon, Toll, Extra Helper, Backload, Demurrage
								</template>

								<template v-else>
								Subcon, Toll, Parking, Extra Helper, Backload, Demurrage, Other Fees, Other Deductions
								</template>

							</small>
							</span>
							<strong>
							{{ summary.vatableFeesTotal | number_format('currency') }}
							</strong>
						</li>

						<!-- VAT -->
						<li
							v-if="companyFlags.isVat"
							class="list-group-item d-flex justify-content-between"
						>
							VAT (12%)
							<strong>{{ summary.vat | number_format('currency') }}</strong>
						</li>

						<!-- WITHHOLDING -->
						<li
							v-if="companyFlags.isVat"
							class="list-group-item d-flex justify-content-between"
						>
							Withholding Tax (2%)
							<strong class="text-danger">
							-{{ summary.withholding | number_format('currency') }}
							</strong>
						</li>
						<!-- ADMIN FEE -->
						<li
						v-if="summary.adminFee > 0 && !companyFlags.isMarvel"
						class="list-group-item d-flex justify-content-between"
						>
						<span>
							Admin Fee
							<small class="text-muted d-block">
							{{ dataParams.admin_fee || 0 }}%
							<template v-if="companyFlags.isRoadwise">
								of Subcon + Helpers + Backload + Demurrage
							</template>
							<template v-else>
								of Subcon Rate
							</template>
							</small>
						</span>
						<strong class="text-danger">
							-{{ summary.adminFee | number_format('currency') }}
						</strong>
						</li>


						<!-- OTHER FEES (NON-VAT) -->
						<li class="list-group-item d-flex justify-content-between">
							<span>
							Other Charges
							<small class="text-muted d-block">

								<template v-if="companyFlags.isMarvel">
								Toll, Parking, Other Fee, Other Deductions (Non-VAT)
								</template>

								<template v-else-if="companyFlags.isRoadwise">
								Other Fees, Other Deductions (Non-VAT)
								</template>

								<template v-else>
								—
								</template>

							</small>
							</span>
							<strong>
							{{ summary.otherFeesTotal | number_format('currency') }}
							</strong>
						</li>

						<!-- TOTAL -->
						<li class="list-group-item d-flex justify-content-between">
							Total Amount
							<strong>{{ summary.totalAmount | number_format('currency') }}</strong>
						</li>

						<!-- PAYMENT -->
						<li class="list-group-item d-flex justify-content-between font-weight-bold">
							PAYMENT AMOUNT
							<span class="text-success">
							{{ summary.paymentAmount | number_format('currency') }}
							</span>
						</li>

			</ul>


      </CCardBody>
    </CCard>
  </CCol>
				</CRow>


		
			</CCardBody> 
		</CCard>
		<!-- <HistoryModal :details="dataParams" @showModal="showHistoryModal = $event" :showModal="showHistoryModal" /> -->
	</div>
</template>
<script> 
import config from '../../config.js';
import axios from '../../axios';
import Swal from 'sweetalert2';
import Search from './search'
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select'
// import 'vue-select/dist/vue-select.css';
import '../../style.css';
import moment from 'moment';
// import HistoryModal from './history_modal/index';

export default {
	mounted(){  

		this.getData();
		this.getVendor();
		this.getVehicleType();
		this.getMakerModel();
		this.getDepot();
		this.getOrigin(); 

	},
	data(){
		return{
			bookingList: [],
			currentPage: 1,
			perPage: 20,
			formModal: false,
			showViewModal: false,
			// showHistoryModal: false,
			dataList: [],
			dataListInactive: [],
			depotName: "",
			dataParams: {
				customer_id: "",
				origin_id: "",
				commodity_id: "",
				ref_no: "",
				status: "",
				tax_type: "",
				delivery_date_from: "",
				delivery_date_to: "",
				total_amount: 0.00,
				bookings: []
			},
			editMode: false, 
			vendorList: {
				data: []
			},
			vehicleTypeList: {
				data: []
			},
			makerModelList: {
				data: []
			},
			depotList: {
				data: []
			},
			originList: {
				data: []
			},
			isLoading: false,
			uploadPercentage: 0,
			config,
			moment,
			fields:  [
				{
					key: 'booking_no', 
					label: 'Booking No.'
				},
				{
					key: 'customer_id_label', 
					label: 'Customer'
				}, 
				
				{
					key: 'delivery_date_label', 
					label: 'Delivery Date'
				},   
				
				{
					key: 'origin_id_label', 
					label: 'Origin'
				}, 
				{
					key: 'depot_name',
					label : 'Depot'
				},
			
				{
					key: 'subcon_rate', 
					label: 'Subcon Rate'
				},
				{
					key: 'toll_fee', 
					label: 'Toll Fee'
				},
					{
					key: 'extra_helper', 
					label: 'Extra Helper'
				},
					{
					key: 'backload_fee', 
					label: 'Backload Fees'
				},
				{
					key: 'demurrage_fee', 
					label: 'Demurrage Fees'
				},
				{
					key: 'other_expenses', 
					label: 'Other Fees'
				},
				{
					key: 'parking_fee', 
					label: 'Parking Fee'
				},
				{
					key: 'other_deductions', 
					label: 'Other Deductions'
				},
				{
					key: 'admin_fee', 
					label: 'Admin Fee'
				},
				{
					key: 'total_amount', 
					label: 'Total Amount'
				}
			],
			fields_marvel:  [
				{
					key: 'booking_no', 
					label: 'Booking No.'
				},
				{
					key: 'customer_id_label', 
					label: 'Customer'
				}, 
				
				{
					key: 'delivery_date_label', 
					label: 'Delivery Date'
				},   
				{
					key: 'plate_no', 
					label: 'Plate No.'
				}, 
				{
					key: 'origin_id_label', 
					label: 'Origin'
				}, 
				{
					key: 'depot_name',
					label : 'Depot'
				},
				{
					key: 'client_rate', 
					label: 'Client Rate'
				}, 
				{
					key: 'admin_fee', 
					label: 'Admin Fee'
				},
				{
					key: 'subcon_rate', 
					label: 'Subcon Rate'
				},
				{
					key: 'total_amount', 
					label: 'Total Amount'
				},
				{
					key: 'toll_fee', 
					label: 'Toll Fee'
				},
					{
					key: 'parking_fee', 
					label: 'Parking Fee'
				},
				{
					key: 'other_expenses', 
					label: 'Other Fees'
				},
				{
					key: 'other_deductions', 
					label: 'Other Deductions'
				},
				
			
				
				{
					key: 'payment_amount', 
					label: 'Payment Amount'
				}
			],
			fields_roadwise:  [
				{
					key: 'booking_no', 
					label: 'Booking No.'
				},
				{
					key: 'customer_id_label', 
					label: 'Customer'
				}, 
				 
				{
					key: 'delivery_date_label', 
					label: 'Delivery Date'
				},   
				{
					key: 'plate_no', 
					label: 'Plate No.'
				}, 
				{
					key: 'origin_id_label', 
					label: 'Origin'
				}, 
				{
					key: 'depot_name',
					label : 'Depot'
				},
				
				{
					key: 'subcon_rate', 
					label: 'Subcon Rate'
				},
				
					{
					key: 'extra_helper', 
					label: 'Extra Helper'
				},
					{
					key: 'backload_fee', 
					label: 'Backload Fees'
				},
				{
					key: 'demurrage_fee', 
					label: 'Demurrage Fees'
				},
				{
					key: 'toll_fee', 
					label: 'Toll Fees'
				},
				{
					key: 'other_expenses', 
					label: 'Other Fees'
				},
				{
					key: 'other_deductions', 
					label: 'Other Deductions'
				},
				{
					key: 'admin_fee', 
					label: 'Admin Fee'
				},
				{
					key: 'total_amount', 
					label: 'Total Amount'
				}
			],
		}
	},
		computed: {
			companyFlags() {
					const name =
					JSON.parse(localStorage.getItem("user_data"))?.company?.company_name
						?.toLowerCase() ?? "";

					return {
					isMarvel: name.includes("marvel"),
					isRoadwise: name.includes("roadwise"),
					isVat: this.dataParams.tax_type === "VAT"
					};
				},
			
				summary() {
					const bookings = this.bookingList.data || [];

					let subconTotal = 0;
					let vatableFeesTotal = 0;
					let otherFeesTotal = 0;
					let vatTotal = 0;
					let withholdingTotal = 0;
					let adminFeeTotal = 0;
					let totalAmount = 0;
					let marvelNonVatTotal = 0;

					const name =
						JSON.parse(localStorage.getItem("user_data"))?.company?.company_name
						?.toLowerCase() ?? "";

					const isMarvel = name.includes("marvel");
					const isRoadwise = name.includes("roadwise");
					const isVat = this.dataParams.tax_type === "VAT";

					const adminRate =
						Number(this.dataParams.admin_fee || 0) / 100;

					bookings.forEach(b => {
						const subcon = Number(b.subcon_rate || 0);
						const toll = Number(b.toll_fee || 0);
						const parking = Number(b.parking_fee || 0);
						const extra = Number(b.extra_helper || 0);
						const backload = Number(b.backload_fee || 0);
						const demurrage = Number(b.demurrage_fee || 0);
						const other = Number(b.other_expenses || 0);
						const otherDed = Number(b.other_deductions || 0);

						/* ROADWISE */
						if (isRoadwise) {
						const vatable = subcon + extra + backload + demurrage + toll;
						const nonVat = other + otherDed;

						subconTotal += subcon;
						vatableFeesTotal += vatable;
						otherFeesTotal += nonVat;

						const adminBase =
							(subcon + extra + backload + demurrage) *
							(isVat ? 1.12 : 1);

						adminFeeTotal += adminBase * adminRate;

						if (isVat) {
							vatTotal += vatable * 0.12;
							withholdingTotal += vatable * 0.02;
							totalAmount += vatable * 1.12 + nonVat;
						} else {
							totalAmount += vatable + nonVat;
						}
						return;
						}

						/* MARVEL */

						if (isMarvel) {
						const vatable = subcon;
						const nonVat =
							toll +
							parking +
							other +
							otherDed;

						subconTotal += subcon;
						vatableFeesTotal += vatable;
						otherFeesTotal += nonVat;

						// track NON-VAT total for payment computation
						marvelNonVatTotal += nonVat;

						// ADMIN FEE (DISPLAY ONLY)
						const clientRate = Number(b.client_rate || 0);
						adminFeeTotal += clientRate - subcon;

						if (isVat) {
							const vat = vatable * 0.12;
							const withholding = vatable * 0.02;

							vatTotal += vat;
							withholdingTotal += withholding;

							// TOTAL = subcon x 1.12 - 2% tax
							const total = (vatable * 1.12) - withholding;
							totalAmount += total;
						} else {
							// NON-VAT MARVEL
							totalAmount += vatable;
						}

						return;
						}



						/* OTHER COMPANIES */
						const vatable =
						subcon + extra + backload + demurrage +
						toll + parking + other + otherDed;

						subconTotal += subcon;
						vatableFeesTotal += vatable;

						const adminBase = isVat ? subcon * 1.12 : subcon;
						adminFeeTotal += adminBase * adminRate;

						if (isVat) {
						vatTotal += vatable * 0.12;
						withholdingTotal += vatable * 0.02;
						totalAmount += vatable * 1.12;
						} else {
						totalAmount += vatable;
						}
					});

				const paymentAmount = isMarvel
					? totalAmount - marvelNonVatTotal
					: totalAmount - withholdingTotal - adminFeeTotal;



					return {
						subconTotal: subconTotal.toFixed(2),
						vatableFeesTotal: vatableFeesTotal.toFixed(2),
						otherFeesTotal: otherFeesTotal.toFixed(2),
						vat: vatTotal.toFixed(2),
						withholding: withholdingTotal.toFixed(2),
						adminFee: adminFeeTotal.toFixed(2),
						totalAmount: totalAmount.toFixed(2),
						paymentAmount: paymentAmount.toFixed(2)
					};
					},



				tableFields() {
					const companyName =
						JSON.parse(window.localStorage.getItem("user_data"))?.company?.company_name
						?.toLowerCase() ?? "";

					if (companyName.includes('roadwise')) {
						return this.fields_roadwise;
					}

					if (companyName.includes('marvel')) {
						return this.fields_marvel;
					}

					return this.fields;
					}

	},
	name: 'Tables',
	components: {Search, Datepicker, vSelect},
	methods: { 

		updatePage(data){
			this.currentPage = data; 
			this.bookingList = this.dataParams.booking.slice(0);
    		this.bookingList.splice(0, (this.currentPage - 1) * this.perPage); 
    		this.bookingList.splice(this.perPage, this.bookingList.length); 
		}, 
	
	// 	let over_total_amount = 0;
	// 	let sub_total = 0;
	// 	let tax_computation = 0;

	// 	const companyName =
	// 		JSON.parse(window.localStorage.getItem("user_data"))?.company?.company_name
	// 			?.toLowerCase() ?? "";

	// 	const isRoadwise = companyName.includes('roadwise');
	// 	const isMarvel = companyName.includes('marvel');

	// 	const mapped = bookings.map(value => {

	// 	// LABELS
	// 	value.customer_id_label = value.customer?.customer_name ?? "N/A";
	// 	value.origin_id_label = value.origin?.setting_name ?? "N/A";
	// 	value.depot_name = value.depot?.setting_name ?? "N/A";
	// 	value.vehicle_type_id_label = value.vendor
	// 		? value.vendor.vendor_name
	// 		: "Company Owned";

	// 	value.delivery_date_label = value.delivery_date
	// 		? moment.unix(value.delivery_date).format('MM/DD/YYYY')
	// 		: "N/A";

	// 	// FEES (define variables properly)
	// 	const subcon_rate = Number(value.subcon_rate ?? 0);
	// 	const toll = Number(value.billable?.toll_fee ?? 0);
	// 	const parking = Number(value.billable?.parking_fee ?? 0);
	// 	const extraHelper = Number(value.billable?.extra_helper ?? 0);
	// 	const backload = Number(value.billable?.backload_fee ?? 0);
	// 	const demurrage = Number(value.billable?.demurrage_fee ?? 0);
	// 	const other = Number(value.billable?.other_expenses ?? 0);

	// 	value.subcon_rate = subcon_rate;
	// 	value.toll_fee = toll;
	// 	value.parking_fee = parking;
	// 	value.extra_helper = extraHelper;
	// 	value.backload_fee = backload;
	// 	value.demurrage_fee = demurrage;
	// 	value.other_expenses = other;

	// 	let vatableAmount = 0;
	// 	let nonVatableAmount = 0;

	// 	// ✅ COMPANY LOGIC
	// 	if (isRoadwise) {
	// 		vatableAmount =
	// 			subcon_rate +
	// 			extraHelper +
	// 			backload +
	// 			demurrage +
	// 			toll;

	// 		nonVatableAmount = 
	// 		subcon_rate +
	// 			extraHelper +
	// 			backload +
	// 			demurrage +
	// 			toll+ 
	// 			other;
	// 	}
	// 	else if (isMarvel) {
	// 		let vat = 0;
	// 		let withholding = 0;

	// 		// NON-VAT BASE
	// 		let baseAmount =
	// 			subcon_rate +
	// 			toll +
	// 			parking +
	// 			other;

	// 		if (this.dataParams.tax_type === 'vat') {
	// 			vat = subcon_rate * 0.12;          // 12% VAT
	// 			withholding = subcon_rate * 0.02;  // 2% tax

	// 			// TOTAL AMOUNT (shown on table)
	// 			value.total_amount = (
	// 				(subcon_rate * 1.12) 
	// 			).toFixed(2);

	// 			// PAYMENT AMOUNT (what vendor receives)
	// 			value.payment_amount = (
	// 				parseFloat(value.total_amount) -
	// 				withholding
	// 			).toFixed(2);

	// 		} else {
	// 			// ✅ NON-VAT
	// 			value.total_amount = baseAmount.toFixed(2);
	// 			value.payment_amount = baseAmount.toFixed(2);
	// 		}

	// 		over_total_amount += parseFloat(value.total_amount);
	// 		return value;
	// 	}
	// 	else {
	// 		vatableAmount = subcon_rate + toll;
	// 		nonVatableAmount = other;
	// 	}

	// 	let vat = 0;
	// 	let withholding = 0;

	// 	// ✅ TAX RULES
	// 	if (this.dataParams.tax_type === 'vat') {
	// 		vat = vatableAmount * 0.12;
	// 		withholding = vatableAmount * 0.02;
	// 	}
	// 	// NON-VAT → no VAT, no withholding

	// 	const total =
	// 		vatableAmount +
	// 		nonVatableAmount +
	// 		vat -
	// 		withholding;

	// 	value.total_amount = total.toFixed(2);

	// 	over_total_amount += total;
	// 	sub_total += vatableAmount + nonVatableAmount;
	// 	tax_computation += vat;

	// 	return value;
	// });

	// return {
	// 	bookings: mapped,
	// 	total_amount: over_total_amount.toFixed(2),
	// 	sub_total: sub_total.toFixed(2),
	// 	tax_computation: tax_computation.toFixed(2)
	// };
	// 	},
			mapBookings(bookings = []) {
						let over_total_amount = 0;
						let sub_total = 0;
						let tax_computation = 0;

						const companyName =
							JSON.parse(window.localStorage.getItem("user_data"))
							?.company?.company_name?.toLowerCase() ?? "";

						const isRoadwise = companyName.includes("roadwise");
						const isMarvel = companyName.includes("marvel");
						const isVat = this.dataParams.tax_type === "VAT";

						const adminRate =
							Number(this.dataParams.admin_fee || 0) / 100;

						const mapped = bookings.map(value => {

							/* ================= LABELS ================= */
							value.customer_id_label = value.customer?.customer_name ?? "N/A";
							value.origin_id_label = value.origin?.setting_name ?? "N/A";
							value.depot_name = value.depot?.setting_name ?? "N/A";
							value.plate_no = value.vehicle?.plate_no ?? "N/A";

							value.delivery_date_label = value.delivery_date
							? moment.unix(value.delivery_date).format("MM/DD/YYYY")
							: "N/A";

							/* ================= FEES ================= */
							const subcon_rate = Number(value.subcon_rate || 0);
							const toll = Number(value.billable?.toll_fee || 0);
							const parking = Number(value.billable?.parking_fee || 0);
							const extraHelper = Number(value.billable?.extra_helper || 0);
							const backload = Number(value.billable?.backload_fee || 0);
							const demurrage = Number(value.billable?.demurrage_fee || 0);
							const other = Number(value.billable?.other_expenses || 0);
							const otherDeductions = Number(value.billable?.other_deductions || 0);

							Object.assign(value, {
							subcon_rate,
							toll_fee: toll,
							parking_fee: parking,
							extra_helper: extraHelper,
							backload_fee: backload,
							demurrage_fee: demurrage,
							other_expenses: other,
							other_deductions: otherDeductions
							});

							/* ================= ROADWISE ================= */
							if (isRoadwise) {
							const vatableBase =
								subcon_rate +
								extraHelper +
								backload +
								demurrage +
								toll;

							const nonVatFees = other + otherDeductions;

							const adminFeeBase =
								(subcon_rate + extraHelper + backload + demurrage) *
								(isVat ? 1.12 : 1);

							const adminFee = adminFeeBase * adminRate;

							if (isVat) {
								const vat = vatableBase * 0.12;
								const withholding = vatableBase * 0.02;

								const totalAmount =
								vatableBase * 1.12 + nonVatFees;

								const paymentAmount =
								totalAmount - withholding - adminFee;

								tax_computation += vat;
								over_total_amount += totalAmount;

								Object.assign(value, {
								admin_fee: adminFee.toFixed(2),
								total_amount: totalAmount.toFixed(2),
								payment_amount: paymentAmount.toFixed(2)
								});
							} else {
								const totalAmount = vatableBase + nonVatFees;
								const paymentAmount = totalAmount - adminFee;

								over_total_amount += totalAmount;

								Object.assign(value, {
								admin_fee: adminFee.toFixed(2),
								total_amount: totalAmount.toFixed(2),
								payment_amount: paymentAmount.toFixed(2)
								});
							}

							sub_total += vatableBase + nonVatFees;
							return value;
							}

					

			/* ================= MARVEL ================= */
			if (isMarvel) {
			const vatableBase = subcon_rate;

			const nonVatFees =
				toll +
				parking +
				other +
				otherDeductions;

			// ✅ ADMIN FEE (DISPLAY ONLY)
			const clientRate = Number(value.client_rate || 0);
			const adminFee = clientRate - subcon_rate;

			let totalAmount = 0;
			let paymentAmount = 0;

			if (isVat) {
				const vat = vatableBase * 0.12;
				const withholding = vatableBase * 0.02;

				// ✅ TOTAL = subcon x 1.12 - 2% tax
				totalAmount = (vatableBase * 1.12) - withholding;

				// ✅ NET PAY = TOTAL - NON-VAT FEES
				paymentAmount = totalAmount - nonVatFees;

				tax_computation += vat;
			} else {
				// ✅ NON-VAT MARVEL
				totalAmount = vatableBase;
				paymentAmount = totalAmount - nonVatFees;
			}

			over_total_amount += totalAmount;
			sub_total += vatableBase;

			Object.assign(value, {
				admin_fee: adminFee.toFixed(2),      // display only
				total_amount: totalAmount.toFixed(2),
				payment_amount: paymentAmount.toFixed(2)
			});

			return value;
			}



							/* ================= OTHER COMPANIES ================= */
							const vatableBase =
							subcon_rate +
							extraHelper +
							backload +
							demurrage +
							toll +
							parking +
							other +
							otherDeductions;

							const adminFeeBase =
							isVat ? subcon_rate * 1.12 : subcon_rate;

							const adminFee = adminFeeBase * adminRate;

							if (isVat) {
							const vat = vatableBase * 0.12;
							const withholding = vatableBase * 0.02;

							const totalAmount = vatableBase * 1.12;
							const paymentAmount =
								totalAmount - withholding - adminFee;

							tax_computation += vat;

							Object.assign(value, {
								admin_fee: adminFee.toFixed(2),
								total_amount: totalAmount.toFixed(2),
								payment_amount: paymentAmount.toFixed(2)
							});
							} else {
							const totalAmount = vatableBase;
							const paymentAmount = totalAmount - adminFee;

							Object.assign(value, {
								admin_fee: adminFee.toFixed(2),
								total_amount: totalAmount.toFixed(2),
								payment_amount: paymentAmount.toFixed(2)
							});
							}

							over_total_amount += Number(value.total_amount);
							sub_total += vatableBase;

							return value;
						});

						return {
							bookings: mapped,
							total_amount: over_total_amount.toFixed(2),
							sub_total: sub_total.toFixed(2),
							tax_computation: tax_computation.toFixed(2)
						};
						},


			getData() {
			this.$showLoading(true);

			axios.get(config.api_path + "/trucker_settlement/" + this.$route.params.id)
			.then(response => {
				this.$showLoading(false);

				this.dataParams = response.data.data;

				
				const result = this.mapBookings(this.dataParams.booking || []);

				this.bookingList.data = result.bookings;
				this.bookingList.total = result.bookings.length;
				this.displayedBooking = [...result.bookings];

				this.dataParams.total_amount = result.total_amount;
				this.dataParams.sub_total = result.sub_total;
				this.dataParams.tax_computation = result.tax_computation;
			})
			.catch(err => {
				console.error(err);
				this.$showLoading(false);
			});
		},
	    getVendor(){

	    	axios.get(config.api_path+'/vendor?page=1&limit=100000')
	    	.then(response => {
	    		this.vendorList = response.data;
	    		this.vendorList.data = this.vendorList.data.map((value, index)=>{
	    			value.value = value.id;
	    			value.label = value.vendor_name;
	    			return value;
	    		})
	    	})

	    },

	    getVehicleType(){

	    	axios.get(config.api_path+'/setting?setting_type=vehicle_type&page=1&limit=100000')
	    	.then(response => {
	    		this.vehicleTypeList = response.data; 
	    	})

	    },

	    getMakerModel(){

	    	axios.get(config.api_path+'/setting?setting_type=maker_model&page=1&limit=100000')
	    	.then(response => {
	    		this.makerModelList = response.data; 
	    	})

	    },

	    getDepot(){

	    	axios.get(config.api_path+'/setting?setting_type=depot&page=1&limit=100000')
	    	.then(response => {
	    		this.depotList = response.data; 
	    	})

	    },

	    getOrigin(){

	    	axios.get(config.api_path+'/setting?setting_type=origin&page=1&limit=100000')
	    	.then(response => {
	    		this.originList = response.data; 
	    	})

	    },

	    updateCompanyOwned(e){
	    	this.dataParams.company_owned = e;
	    },

	    getStatus(status){

	    	if(status == "active"){return "Active";}
	    	if(status == "inactive"){return "Inactive";}
	    	if(status == "incoming"){return "Incoming";}
	    	if(status == "archive"){return "Archive/Sold";} 

	    },

	    transimission(trans){
	    	if(trans == "manual"){return "Manual";}
	    	if(trans == "automatic"){return "Automatic";}
	    },

	    fuelType(fuel){
	    	if(fuel == "gasoline"){return "Gasoline";}
	    	if(fuel == "diesel"){return "Diesel";}
	    },

	    backToTable(){
	    	this.$router.push('/main/trucker_settlement')
	    },

	    download(){ 
	    	this.$showLoading(true)
	    	axios.get(config.api_path+'/reports/trucker_settlement/'+this.$route.params.id)
	    	.then(response=>{
				this.$showLoading(false)
	    		window.open(config.main_path.replace('/index.php', '')+'/'+response.data.file) 
	    		setTimeout(() => {
					axios.get(`${config.api_path}/remove-file`,{
						params : {
							filename : response.data.file
						}
					})	
				}, 2000);
	    	})
			.catch(err => {
				this.$showLoading(false)
			})
	    }

 	}
}
</script>
